module.exports = __webpack_public_path__ + "img/authen_wuliao.4de7cf76.png";